<div class="emphasis-text">
    <div class="emphasis-text__inner" [ngClass]="{'-no-underline': !underline, '-multilines': multiLines}">
        <ng-content></ng-content>
    </div>
</div>
